import React from 'react';
import { ActivityIcon, AlertCircleIcon, BoneIcon, ZapOffIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { TrustBadges } from './ui/TrustBadges';
export function ProblemSection() {
  const problems = [{
    icon: <ActivityIcon className="w-8 h-8 text-red-500" data-id="element-161" />,
    title: 'Lesión de Menisco',
    desc: 'Dolor agudo al doblar o girar la rodilla.'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-red-500" data-id="element-162" />,
    title: 'Dolor por Ligamentos (LCA)',
    desc: 'Inestabilidad y molestias constantes al caminar.'
  }, {
    icon: <ZapOffIcon className="w-8 h-8 text-red-500" data-id="element-163" />,
    title: 'Hinchazón y Rigidez',
    desc: 'Dificultad para mover la articulación por las mañanas.'
  }, {
    icon: <BoneIcon className="w-8 h-8 text-red-500" data-id="element-164" />,
    title: 'Desgaste por Artritis',
    desc: 'Dolor crónico que empeora con el clima frío.'
  }];
  return <section className="w-full bg-slate-50 py-16 px-4 border-y border-slate-200" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="text-center mb-12" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-168">
            ¿Sufres de Dolor de Rodilla?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-169">
            El dolor articular no solo afecta tu movilidad, sino que te roba la
            energía y te impide disfrutar de las actividades que amas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-170">
          {problems.map((prob, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-start gap-4" data-id="element-171">
              <div className="bg-red-50 p-3 rounded-xl shrink-0" data-id="element-172">
                {prob.icon}
              </div>
              <div data-id="element-173">
                <h3 className="text-xl font-bold text-slate-800 mb-2" data-id="element-174">
                  {prob.title}
                </h3>
                <p className="text-slate-600" data-id="element-175">{prob.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-176">
          <p className="text-2xl font-bold text-blue-700 mb-8" data-id="element-177">
            Existe una solución natural y efectiva...
          </p>
          <div className="max-w-md mx-auto" data-id="element-178">
            <CTAButton text="Quiero Aliviar Mi Dolor – $699 MXN" data-id="element-179" />
            <TrustBadges className="mt-4" data-id="element-180" />
          </div>
        </div>
      </div>
    </section>;
}